import React, { useState } from 'react';
import { Card, Button, ProgressBar, Alert, Form } from 'react-bootstrap';
import Resumable from 'resumablejs';
import axios from 'axios';

const UploadVideo = () => {
  const AuthToken = localStorage.getItem("AuthUser");

  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [videoPreview, setVideoPreview] = useState('');
  const [error, setError] = useState(null);

  const initUploader = () => {
    const resumable = new Resumable({
      target: `${process.env.REACT_APP_API_URL}/video-upload`, // Your API endpoint
      query: { record_id: 1 }, // Send the record ID or any other necessary info
      headers: { 
        Accept: "application/json",
        Authorization: `Bearer ${AuthToken}`
      },
      fileType: ["mp4"],
      testChunks: false,
      throttleProgressCallbacks: 1,
      chunkSize: 2 * 1024 * 1024, // Set chunk size to 2MB
        simultaneousUploads: 1,
    });
  
    resumable.assignBrowse(document.getElementById("videoFile"));
  
    resumable.on("fileAdded", () => {
      setUploading(true);
      resumable.upload();
    });
  
    resumable.on("fileProgress", (file) => {
      setProgress(Math.floor(file.progress() * 100));
    });
  
    resumable.on("fileSuccess", (file, response) => {
      const data = JSON.parse(response);
      setVideoPreview(data.path);
      setUploading(false);
      alert("Video uploaded successfully!");
    });
  
    resumable.on("fileError", (file, response) => {
      setError("Video upload failed!");
      setUploading(false);
    });
  };

  return (
    <div className="container mt-5">
      <Card>
        <Card.Body>
          <Card.Title>Upload Your Video</Card.Title>

          <Form>
            <Form.Group controlId="videoFile">
              <Form.Label>Select Video File (MP4 only)</Form.Label>
              <Form.Control
                type="file"
                accept="video/mp4"
                // onChange={initUploader}
              />
            </Form.Group>

            {uploading && (
              <div>
                <p>Uploading: {progress}%</p>
                <ProgressBar now={progress} label={`${progress}%`} />
              </div>
            )}

            {error && (
              <Alert variant="danger">
                <strong>Error:</strong> {error}
              </Alert>
            )}

            {videoPreview && (
              <div className="mt-3">
                <h5>Video Preview:</h5>
                <video src={videoPreview} controls width="100%" />
              </div>
            )}

            <Button variant="primary" className='mt-4' disabled={uploading}>
              {uploading ? "Uploading..." : "Start Upload"}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default UploadVideo;
